import { CommonModule } from '@angular/common';
import { Component, EventEmitter, input, Input, OnInit, Output } from '@angular/core';
import { ModalService } from '../modal/modal.service';
import { formatDate } from '@angular/common';
import { BaseComponent } from '@app/components/base/base.component';
import { StatusHistory } from '@app/models/status-history.enum';


@Component({
  selector: 'app-template-history',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './template-history.component.html',
  styleUrl: './template-history.component.css'
})
export class TemplateHistoryComponent implements OnInit {
  @Input() title: string;
  @Input() subtitle: string;
  @Input() data: any[];
  @Input() btn1: string;
  @Input() btn2: string;
  @Output() closeModal: EventEmitter<any> = new EventEmitter();
  @Output() actionBtn2: EventEmitter<any> = new EventEmitter();

  objectKeys = Object.keys;
  statusHistory = StatusHistory;

  constructor(private modalService: ModalService
  ) { }

  ngOnInit() {
    if (this.data) {
      this.data.sort((a, b) => new Date(b.updatedDate).getTime() - new Date(a.updatedDate).getTime());
    }
  }


  close() {
    this.modalService.closeModal()
  }

  format(date: any, minutes?: boolean) {
    if (minutes) {
      if (date) return formatDate(date, 'dd-MMM-yyyy', 'es-Es')?.toUpperCase();
      return '';
    } else {
      if (date)
        return formatDate(date, 'dd-MMM-yyyy, HH:mm', 'es-Es')?.toUpperCase();
      return '';
    }
  }

  
}
